import ConsentAware from '@utmb/design-system/consent/ConsentAware';
import { CookieCategorieEnum } from '@utmb/design-system/types/cookie-consent-helper';
import { ReactElement, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

export const ConsentAwareInjector = (): ReactElement | null => {
    const [target, setTarget] = useState<Element | null>(null);
    const [container, setContainer] = useState<Element | null>(null);
    const wrapRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const elementTarget = document.querySelector('#consentAwareRequired');
        setTarget(elementTarget);

        const elementContainer = document.querySelector('#consentAwareContainer');
        setContainer(elementContainer);
    }, []);

    useEffect(() => {
        if (target && wrapRef.current) {
            wrapRef.current.appendChild(target);
        }
    }, [target]);

    if (!target || !container || !window.location.pathname.includes('/contact')) return null;

    const consents: CookieCategorieEnum[] = [CookieCategorieEnum.FUNCTIONNAL];

    return (
        <>
            {createPortal(
                <ConsentAware category={consents}>
                    <div ref={wrapRef}></div>
                </ConsentAware>,
                container
            )}
        </>
    );
};
